export default __webpack_public_path__ + "static/Inter-Regular-9cd7588f47651215d52f3cec8c6f4a44.ttf";